export const new_message = `subscription new_message{
    new_message{
        id
        time
        type
        subject
        subject_en
        text
        text_en
        awaiting_acception
        accepted
        unread
        has_attachment
    }
}`;
